module.exports = __webpack_public_path__ + "img/code_wu.10a2c97b.png";